"use strict";

exports.__esModule = true;
exports.DefaultCommentSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input._id;
}
function renderItemText(input) {
  return input.comment;
}
function itemPredicate(query, value) {
  var q = query.toLowerCase();
  return value.comment.toLowerCase().indexOf(q) !== -1;
}

/**
 * Allows a user to select predefined default comment.
 */
var DefaultCommentSelector = exports.DefaultCommentSelector = function DefaultCommentSelector(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_Core.Selector, _extends({
    placeholder: translate("DefaultCommentSelector.placeholder.notSelected", "Select predefined comment"),
    width: 250,
    getKey: getKey,
    renderItemText: renderItemText,
    itemPredicate: itemPredicate
  }, props));
};